import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import Reveal from "./Reveal";

function Counter({ to = 1100, duration = 1600 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {val.toLocaleString("it-IT")}
      <span className="text-sage-400">+</span>
    </span>
  );
}

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-sage-50 py-16 lg:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="font-serif text-6xl md:text-7xl lg:text-8xl leading-none tracking-tight text-forest-900">
              <Counter to={1100} />
            </div>
            <p className="mt-3 text-xs uppercase tracking-[0.2em] font-medium text-sage-600">
              Clienti che si affidano a noi
            </p>
          </div>
          <p className="max-w-md text-base font-light text-forest-700 leading-relaxed md:text-right">
            Oltre <span className="text-forest-900 font-medium">1.100 famiglie e aziende</span> hanno
            già scelto Rossi Energia per risparmiare in bolletta, con costi
            chiari e assistenza continua.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
